const truncate = (input, number, max = 15) =>
  input.length > max ? `${input.substring(0, number)}...` : input;

export default truncate;
